export default __webpack_public_path__ + "static/media/callOfDuty.a450471d.jpg";